import React from "react";

const InputContainer = ({ title, iconTitle, bold, fontSize14, width, spaceBetween, flexDirectionHorizontalFlexContainer, heightHorizontalFlexContainer, widthHorizontalFlexContainer, gapHorizontalFlexContainer, alignItemsHorizontalFlexContainer, children }) => {
    return <div className={"horizontalFlexContainer"} style={{
        gap: gapHorizontalFlexContainer ? gapHorizontalFlexContainer : "20px",
        alignItems: alignItemsHorizontalFlexContainer ? alignItemsHorizontalFlexContainer : "center",
        flexGrow: 1,
        flexDirection: flexDirectionHorizontalFlexContainer ? flexDirectionHorizontalFlexContainer : null,
        justifyContent: spaceBetween ? "space-between" : "flex-start",
        height: heightHorizontalFlexContainer ? heightHorizontalFlexContainer : null,
        width: widthHorizontalFlexContainer ? widthHorizontalFlexContainer : null
    }}>
        {title ? <div className="ContentName" style={{ fontWeight: bold ? "700" : "400", width: width ? width : "90px", fontSize: bold && !fontSize14 ? "22px" : "14px" }}>{title}</div> : iconTitle ? <img className="icons-title-dropdown" src={iconTitle} /> : null}
        {children}
    </div>;
};
export default InputContainer;
